export default __webpack_public_path__ + "static/media/trash_on_over.990b259a.svg";